<template>

    <div class="container">

        <div class="my-4">
            <h1>{{ __('Adresse erstellen') }}</h1>
        </div>

        <div class="row">
            <div class="col-md-6">

                <form @submit.prevent="form.post(route('addresses.store'))">
                    <form-fields :form="form" :countries="countries" />
                </form>

            </div>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    country_id: 1,
                    company: null,
                    salutation: null,
                    title: null,
                    first_name: null,
                    last_name: null,
                    city: null,
                    street: null,
                    house_number: null,
                    zip_code: null,
                    county: null,
                    phone: null,
                    notes: null,
                    default_billing_address: false,
                    default_delivery_address: false,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>